import React from 'react';

import { Switch, Route, Redirect } from 'react-router-dom';
import PageTemplate from '../components/common/pageTemplate';

import pages from './routes';

export default class ActivePageContainer extends React.Component {

  render() {
    // const { device, user, conf } = this.props;
    // if (!device.modelNumber) return null;
    const { user, resources } = this.props;
    // const combinedGroupRoles = this.props.resources.groups.reduce((sum, item) => {
      // iterate through each group, and if its a boolean then add it to the sum, if its true then make it true, if not ignore it (additive)

    // }, {})

    const routes = pages(user, resources);

    return (
      <Switch>
        {routes.map(page => {
          return (
            <Route
              key={page.basePath}
              path={page.basePath}
              exact={page.exact || undefined}
              render={(routerProps) => {
                if (page.disabled) {
                  return <Redirect to="/" />;
                }
                return (
                  <PageTemplate
                    {...page}
                    {...this.props}
                    {...routerProps}
                  />
                )
              }}
            />
        )})}
        <Redirect exact from ="/" to="/devices" />
      </Switch>
    );
  }
}
